import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Scale, BarChart3, Terminal, Microscope, Building } from 'lucide-react';

const IndustryCard = ({ icon: Icon, title, description, link }) => {
  return (
    <div className="bg-apple-800/30 backdrop-blur-md rounded-xl border border-apple-700/50 p-6 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-xl hover:shadow-sortio-primary/10 hover:border-sortio-primary/50 group">
      <div className="flex flex-col h-full">
        <div className="flex items-center mb-4">
          <div className="bg-apple-700/50 p-3 rounded-lg">
            <Icon className="h-7 w-7 text-sortio-primary group-hover:text-sortio-secondary transition-colors duration-300" />
          </div>
          <h3 className="text-xl font-semibold ml-3">{title}</h3>
        </div>
        <p className="text-apple-200 mb-6 flex-grow">{description}</p>
        <Link 
          to={link} 
          className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors mt-auto"
        >
          Learn More <ChevronRight className="h-4 w-4 ml-1" />
        </Link>
      </div>
    </div>
  );
};

const IndustriesSection = () => {
  const industries = [
    {
      icon: Scale,
      title: "Law Firms",
      description: "Streamline case file organization and ensure client-matter centric document management with enhanced eDiscovery capabilities.",
      link: "/for-law-firms"
    },
    {
      icon: BarChart3,
      title: "Finance",
      description: "Organize financial documents with precision while maintaining robust security and regulatory compliance.",
      link: "/business" // Placeholder link
    },
    {
      icon: Building,
      title: "Marketing",
      description: "Keep creative assets organized and easily retrievable to accelerate campaign development and asset reuse.",
      link: "/business" // Placeholder link
    },
    {
      icon: Terminal,
      title: "IT",
      description: "Manage technical documentation, code repositories, and project files with intelligent categorization.",
      link: "/business" // Placeholder link
    },
    {
      icon: Microscope,
      title: "R&D",
      description: "Organize research data, literature, and experiments to improve collaboration and knowledge retrieval.",
      link: "/business" // Placeholder link
    }
  ];

  return (
    <div className="my-16">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">Built for your workflow</h2>
        <p className="text-xl text-apple-200 max-w-2xl mx-auto">
          Whether you're a two person practice or a 50 seat team, Sortio adapts to how your industry already files documents.
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {industries.map((industry, index) => (
          <IndustryCard 
            key={index}
            icon={industry.icon}
            title={industry.title}
            description={industry.description}
            link={industry.link}
          />
        ))}
      </div>
    </div>
  );
};

export default IndustriesSection;